import { ACCOUNT_TYPE_CORPORATE } from '../constants'

export const createHeroView = id => () => import('../views/CreateHeroView').then(m => m.default(id))
export const createNavigationView = id => () => import('../views/CreateNavigationView').then(m => m.default(id))

const About = () => import('../components/About/About.vue')
const AdvertiserView = () => import('../components/About/AdvertiserView.vue')
const EmployerView = () => import('../components/About/EmployerView.vue')

const MoreEfficientManpowerSearch = () => import('../components/About/MoreEfficientManpowerSearch.vue')
const MoreEfficientJobSearch = () => import('../components/About/MoreEfficientJobSearch')

export const routes = () => [
  { path: '/bemutato', redirect: '/kisokos' },
  {
    path: '/kisokos',
    components: {
      default: About,
      hero: createHeroView('about'),
      navigation: createNavigationView()
    },
    children: [
      {
        path: 'maganszemely',
        component: AdvertiserView,
        meta: {
          pageTitle: 'How It Works - Advertiser'
        }
      },
      {
        path: 'maganszemely/munkaado',
        component: EmployerView,
        meta: {
          pageTitle: 'How It Works - Private Employer'
        }
      },
      {
        path: 'ceg',
        component: EmployerView,
        props: {
          accountType: ACCOUNT_TYPE_CORPORATE
        },
        meta: {
          pageTitle: 'How It Works - Company'
        }
      }
    ],
    meta: {
      pageTitle: 'How It Works'
    }
  },
  {
    path: '/tippek-a-munkakereseshez',
    components: {
      default: MoreEfficientJobSearch,
      hero: createHeroView('about'),
      navigation: createNavigationView()
    },
    meta: {
      pageTitle: 'Profile - More Efficient Job Search'
    }
  },
  {
    path: '/tippek-a-munkaero-kereseshez',
    components: {
      default: MoreEfficientManpowerSearch,
      hero: createHeroView('about'),
      navigation: createNavigationView()
    },
    meta: {
      pageTitle: 'Profile - More Efficient Manpower Search'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/about.js